import React, { useContext } from "react";
import EBint from "../productPages/EBint";
import EFsa from "../productPages/EFsa";
import EVsa from "../productPages/EVsa";
import EHfsp from "../productPages/EHfsp";
import EFsbi from "../productPages/EFsbi";
import { data as DATA_PRODUCTS } from "../DATA_PRODUCTS";

import OpacityContext from "../OpacityContext";

// import '../productPages/progPageAndProductStyle.css';

export default function PageElevator({
  handleWarningMessageText,
  handleDropzoneChanges,
  handleContinueButtonDisabled
}) {
  const { productIndex } = useContext(OpacityContext);

  //* Map product label to component
  const componentMap = {
    bint: EBint,
    fsa: EFsa,
    fsbi: EFsbi,
    hfsp: EHfsp,
    vsa: EVsa
  };

  //* get the label name based on productIndex
  const label =
    DATA_PRODUCTS[productIndex] && DATA_PRODUCTS[productIndex].label; //* this is mapping the label to the data with a safe check bc our compiler doesn't support optional chaining

  //* We will create a dynamic component that gets selected and we will render out just that instead of listing out conditional renders for each one
  const ProductComponent = componentMap[label];

  return (
    <div className="pageContainer">
      {ProductComponent && (
        <ProductComponent
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      )}
    </div>
  );
}
